import React from 'react';
import { generateUniqueIdForSvg } from '../../../../helpers/svg';

export default () => {
  const idPaint1 = generateUniqueIdForSvg();
  const idPaint2 = generateUniqueIdForSvg();
  const idPaint3 = generateUniqueIdForSvg();

  return (
    <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 22H18C19.1046 22 20 21.1046 20 20V9L15 7L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22Z"
        fill={`url(#${idPaint1})`}
      />
      <path
        d="M6 22H18C19.1046 22 20 21.1046 20 20V9L15 7L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22Z"
        fill={`url(#${idPaint2})`}
        fill-opacity="0.5"
      />
      <path d="M13 7.5V2L20 9H14.5C13.6716 9 13 8.32843 13 7.5Z" fill={`url(#${idPaint3})`} />
      <defs>
        <linearGradient
          id={idPaint1}
          x1="15.2"
          y1="2"
          x2="16.8215"
          y2="18.8699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6CE0FF" />
          <stop offset="0" stop-color="#4894FE" />
          <stop offset="1" stop-color="#4894FE" />
        </linearGradient>
        <radialGradient
          id={idPaint2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.6667 2.625) rotate(133.623) scale(12.562 7.41695)"
        >
          <stop offset="0.362364" stop-color="#4A43CB" />
          <stop offset="0" stop-color="#4A43CB" />
          <stop offset="1" stop-color="#4A43CB" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id={idPaint3}
          x1="16.4883"
          y1="4.91667"
          x2="14.7383"
          y2="7.83333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9FF0F9" />
          <stop offset="0" stop-color="#B3E0FF" />
          <stop offset="1" stop-color="#B3E0FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
